import React from "react";
import { View, StyleSheet } from "react-native";
import NtRootPageContainer from "../../root/components/NtRootPageContainer";
import NtPageSection from "../../components/NtPageSection";
import NtPagination from "../../components/NtPagination";
import NtSearchBar from "../../components/NtSearchBar";
import NtTabController from "../../components/NtTabController";
import NtListHeader from "../../components/NtListHeader";
import NtListEmpty from "../../components/NtListEmpty";
import NtReportScheduleItem from "../components/NtReportScheduleItem";
import { fetchReportSchedules } from "../../api/billing";
import Logger from "../../common/utils/Logger";
import settings from "../../config/settings";
import BasePinController from "./BasePinController";
import reportschedulecolumndata from "../data/reportschedulecolumndata";
import cronstrue from "cronstrue";
import {
  asyncStorageSetData,
  parseDisplayDate,
  parseSimpleDisplayDate,
  showToast,
} from "../../common/utils/ControllerUtils";

class ReportScheduleController extends BasePinController {
  state = {
    ...super.state,
    loading: false,
    totalItems: 0,
    data: [],
    searchText: "",
    searchFilter: null,
    selectedTab: null,
    page: 1,
  };

  tabs = [
    { id: "active", title: "Active" },
    { id: "inactive", title: "Inactive" },
  ];

  column_location = "@reportschedule_column_storage";

  componentDidMount() {
    this.setState({ selectedTab: this.tabs[0] });
    this.handleDefaultColumnsFetch(
      this.column_location,
      reportschedulecolumndata.filter((each) => each.default === true),
    );
    this.handleDataFetch();
  }


  handleDataFetch = async () => {
    this.setState({ loading: true });
    const response = await fetchReportSchedules(
      this.state.page,
      settings.pageSizeLoad,
      this.state.searchText,
      { status: this.state.selectedTab?.id },
    );
    Logger("ReportSchedules fetch response", response);
    if (response.ok) {
      this.setState({
        data: response.data?.data || [],
        totalItems: response.data?.total || 0,
      });
    }
    this.setState({ loading: false });
  };

  handleExportFetch = async () => {
    const response = await fetchReportSchedules(
      1,
      10000000,
      this.state.searchText,
      { status: this.state.selectedTab?.id },
    );
    return response.ok ? response.data?.data || [] : [];
  };

  handleExportDataParce = (item, column) => {
    if (column === "creationdate") return parseSimpleDisplayDate(item[column]);
    if (column === "receiver") return `"${item[column]}"`;
    if (column === "schedule") return cronstrue.toString(item[column]);
    if (column === "lastrun") return item[column] ? `"${parseDisplayDate(item[column])}"` : "N/A";
    if (column === "use_local_timezone") return item[column] == 0 ? "UTC" : "Local Time";
    return item[column];
  };

  handleSearch = (text) => {
    this.setState({ searchText: text, page: 1 }, () => this.handleDataFetch());
  };

  handlePageChange = (nextPage) => {
    this.setState({ page: nextPage }, () => this.handleDataFetch());
  };

  handleTabChange = (tab) => {
    if (tab?.id === this.state.selectedTab?.id) return;
    this.setState(
      { selectedTab: tab, searchText: "", data: [], page: 1 },
      () => this.handleDataFetch(),
    );
  };

  renderRow = (item, index) => (
    <NtReportScheduleItem
      key={item?.id}
      item={item}
      columns={this.state.columns}
      onUpdate={() => {
        this.setState({ page: 1 }, () => this.handleDataFetch());
        showToast("Success", "Successfully updated a report schedule");
      }}
    />
  );

  render() {
    const canEdit = this.handlePermissionCheck(settings.permissionTypeEdit);
    const count = this.state.totalItems || 0;
    const subtitle = `Scheduled report deliveries via email · ${count} schedule${count === 1 ? "" : "s"}`;

    const filters = (
      <NtTabController
        options={this.tabs}
        selection={this.state.selectedTab}
        onPress={this.handleTabChange}
      />
    );

    const searchBar = (
      <NtSearchBar value={this.state.searchText} onChangeText={this.handleSearch} />
    );

    return (
      <NtRootPageContainer
        pageTitle="Report Schedule"
        pageSubtitle={subtitle}
        permission={this.handlePermissionCheck()}
      >
        <NtPageSection
          filters={filters}
          search={searchBar}
          footer={
            <NtPagination
              page={this.state.page}
              pageSize={settings.pageSizeLoad}
              total={this.state.totalItems}
              onChange={this.handlePageChange}
            />
          }
        >
          <View style={styles.tableWrap}>
            <NtListHeader
              visible={this.state.data?.length > 0}
              headerContainerStyle={{ marginRight: canEdit ? 35 : 0 }}
              columns={reportschedulecolumndata}
              selectedColumns={this.state.columns}
              onColumnUpdate={(updated) => {
                asyncStorageSetData(this.column_location, updated);
                this.setState({ columns: updated });
              }}
              exportFileName="report-schedule"
              exportDataParser={this.handleExportDataParce}
              exportFetchDataAsync={this.handleExportFetch}
            />
            <NtListEmpty visible={this.state.data?.length === 0} />
            {this.state.data?.map((each, index) => this.renderRow(each, index))}
          </View>
        </NtPageSection>
      </NtRootPageContainer>
    );
  }
}

const styles = StyleSheet.create({
  tableWrap: { paddingHorizontal: 14, paddingVertical: 4 },
});

export default ReportScheduleController;
